/* Yummy Gummy — PDP Cross-sell: AJAX add-to-cart only. Carousel
   navigation (arrows/swipe) is entirely owned by assets/yg-carousel.js
   now that this section reuses the shared carousel shell — nothing to
   duplicate here. This file just wires up the "Add" pill rendered by
   snippets/yg-product-card.liquid's cta_mode:"add_to_cart" path, mirroring
   the proven fetch('/cart/add.js') + cart-drawer-refresh pattern already
   in assets/yg-product.js's initBundle(). Safe & idempotent. */
(function () {
  'use strict';

  function initAdd(root) {
    (root || document).querySelectorAll('[data-pdp-cs-add]').forEach(function (btn) {
      if (btn.__pdpBound) return;
      btn.__pdpBound = true;

      btn.addEventListener('click', function () {
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId || btn.disabled) return;

        btn.disabled = true;
        var originalHtml = btn.innerHTML;

        /* This button is a .yg-pill: its visible label lives in its two
           stacked .yg-pill__text spans (see assets/yg-buttons.css — the pill
           is fixed-height + overflow:hidden and only ever shows those spans).
           Setting btn.textContent would DELETE both spans, leaving a bare
           text node the pill can't lay out — it clips to a tiny broken-
           looking blob. So update the spans' text in place instead, keeping
           the pill's structure intact. Falls back to textContent only if the
           spans somehow aren't present. */
        var labelSpans = btn.querySelectorAll('.yg-pill__text');
        function setLabel(text) {
          if (labelSpans.length) {
            labelSpans.forEach(function (s) { s.textContent = text; });
          } else {
            btn.textContent = text;
          }
        }
        /* Show the pill's CSS ring spinner while the add is in flight (see
           .yg-pill.is-loading in assets/yg-buttons.css), same feel as the
           main Add-to-cart button's loading state — not a bare "…". */
        btn.classList.add('is-loading');

        var body = { items: [{ id: variantId, quantity: 1 }] };
        var drawer = document.querySelector('cart-drawer');
        if (drawer && drawer.getSectionsToRender) {
          body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
        }

        fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify(body)
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (drawer && drawer.renderContents && res.sections) {
              drawer.renderContents(res);
            }
            btn.classList.remove('is-loading');
            setLabel('Added');
            window.setTimeout(function () {
              btn.innerHTML = originalHtml;
              btn.classList.remove('is-loading');
              btn.disabled = false;
            }, 1800);
          })
          .catch(function () {
            btn.innerHTML = originalHtml;
            btn.classList.remove('is-loading');
            btn.disabled = false;
          });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAdd(document); });
  } else {
    initAdd(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAdd(e.target); });

  // The recommendations fallback path injects its cards later via fetch
  // (assets/global.js's ProductRecommendations) — re-scan once that
  // happens so its Add buttons get bound too.
  var reco = document.querySelectorAll('product-recommendations');
  if (reco.length && 'MutationObserver' in window) {
    reco.forEach(function (el) {
      new MutationObserver(function () { initAdd(el); }).observe(el, { childList: true });
    });
  }
})();
